// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiConfig: {
    apiUrl: 'https://api2.prod.myprize.it/v1',
    client_id: '2',
    client_secret: 'dnqEUxi1ju8AV7YbvqPW5OWPcYSfE71wNTqcermI',
    grant_type: 'password',
    scope: null
  },
  summernoteConfig: {
    dialogsInBody: true,
    height: '400px',
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
